export default __webpack_public_path__ + "static/typography-image-u-e4e2dcf42324601747b6f42ce727a4a4.png";